import { LoadingButton } from "@mui/lab";
import { Alert, Button, Divider, Icon, Stack } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionHeader from "../../../components/shared/SectionHeader";
import { RootState } from "../../../slices/Store";
import { ValidateSmsCampaignTemplate } from "../../../validations/SmsCampaignValidation";
import {
    setInitialState,
    setSmsCampaignDefinition,
    setSmsCampaignType,
    smsCampaignNextStep,
} from "../smsCampaignSlice/SmsCampaignSlice";
import SmsCampaignTextArea from "./SmsCampaignTextArea";

export default function SmsCampaignTemplate() {
    const dispatch = useDispatch();
    const smsCampaign = useSelector((state: RootState) => state.smsCampaign);

    const [error, setError] = useState<string | null>(null);

    const handleMessageChange = (template: string) => {
        dispatch(
            setSmsCampaignDefinition({
                ...smsCampaign.definition,
                template,
            })
        );
    };

    const handlePrevious = () => {
        dispatch(setSmsCampaignType(null));
    };

    const handleNext = () => {
        const errorMessage = ValidateSmsCampaignTemplate(smsCampaign);

        if (errorMessage) {
            setError(errorMessage);
            return;
        }

        dispatch(smsCampaignNextStep());
    };

    return (
        <Stack spacing={2}>
            <SectionHeader title="انتخاب متن" />

            <SmsCampaignTextArea
                template={smsCampaign.definition.template ?? ""}
                onTextChange={handleMessageChange}
            />

            <Divider />

            {error && <Alert severity="error">{error}</Alert>}

            <Stack direction="row" justifyContent="space-between">
                <Button
                    onClick={handlePrevious}
                    variant="outlined"
                    startIcon={<Icon>navigate_next</Icon>}
                >
                    مرحله قبل
                </Button>

                <LoadingButton
                    onClick={handleNext}
                    variant="contained"
                    color="primary"
                    endIcon={<Icon>navigate_before</Icon>}
                >
                    مرحله بعد
                </LoadingButton>
            </Stack>
        </Stack>
    );
}
